import { render, staticRenderFns } from "./RestorePassword.vue?vue&type=template&id=36a1b7e0&scoped=true&"
import script from "./RestorePassword.vue?vue&type=script&lang=js&"
export * from "./RestorePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a1b7e0",
  null
  
)

export default component.exports